<div
    class="agpr-monitoringSourcePickerField"
    [ngClass]="{
        'agpr-monitoringSourcePickerField--horizontal': field.horizontalOrientation,
        'agpr-contextMenu-parent': !field.horizontalOrientation,
        'agpr-monitoringSourcePickerField--withSortOrder': showSortOrder
    }"
    [class.ui-g]="field.horizontalOrientation"
    role="group"
    aria-describedby="dataSource_errors"
>
    <div
        class="agpr-monitoringSourcePickerField-inputGroup"
        role="group"
        [attr.aria-label]="field.dataSourceLabel | localize"
        [class.agpr-monitoringSourcePickerField-inputGroup--horizontal]="field.horizontalOrientation"
    >
        <div
            *ngIf="!!field.dataSourceLabel"
            class="agpr-monitoringSourcePickerField-heading"
        >
            <div class="agpr-monitoringSourcePickerField-heading-dataSourceLabel">
                {{ field.dataSourceLabel | localize }}
                @if (block?.displayElement?.automaticallyGenerated) {
                    <span
                        class="agpr-monitoringSourcePickerField-heading-tooltip fa-regular fa-circle-info agpr-textInput-tooltip"
                        role="img"
                        [agprTooltip]="'PageBuilder.blockType.curation.source.lock'"
                    ></span>
                }
            </div>
        </div>

        @let disabledViewSourceMessage = sourceType && unSupportedViewSourceTypes.includes(sourceType)
            ? 'Monitoring.sourcePickerField.viewSource.tooltip.unableToView'
            : 'Monitoring.sourcePickerField.header.viewSource';

        <div class="agpr-contextMenu top right">
            <agpr-button
                class="agpr-monitoringSourcePickerField-heading-sourceLink"
                icon="fa-regular fa-duotone fa-eye"
                (click)="viewSource($event)"
                [tooltip]="disabledViewSourceMessage"
                tooltipPosition="left"
                [disabled]="disabledViewSourceButton"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        </div>

        <div class="agpr-monitoringSourcePickerField-inputRow">
            <agpr-dropdown
                [id]="id + '.dropdown'"
                [options]="field.dataSourceOptions"
                [ngClass]="{'agpr-monitoringSourcePickerField-dropdown--showFilters': field.showFilters && !field.horizontalOrientation,
                            'agpr-monitoringSourcePickerField-dropdown--withTooltip': sourceType === seriesType.coverageSurge}"
                [(ngModel)]="sourceDropdownOption"
                [showTooltip]="true"
                [infoCircleTooltip]="sourceType === seriesType.coverageSurge ? 'Monitoring.sourcePickerField.surgeSource.tooltip' : null"
                [disabled]="sourceType === seriesType.currentSearch || block?.displayElement?.automaticallyGenerated"
                (change)="viewSourceError = ''"
                (ngModelChange)="selectType($event.value)"
            ></agpr-dropdown>
            <div
                class="agpr-monitoringSourcePickerField-autocompleteWrapper"
                [class.agpr-monitoringSourcePickerField-autocompleteWrapper--withFilters]="field.showFilters"
                [class.agpr-monitoringSourcePickerField-autocompleteWrapper--horizontal]="field.horizontalOrientation"
            >
                <agpr-autocomplete
                    [id]="id + '.autocomplete'"
                    class="agpr-monitoringSourcePickerField-autocomplete"
                    panelStyleClass="agpr-monitoringSourcePickerField-overlayPanel"
                    [suggestions]="suggestions$"
                    labelField="label"
                    [placeholder]="placeholder[sourceType] | localize"
                    [dropdown]="true"
                    [(ngModel)]="selectedSource"
                    (itemSelected)="selectItem($event)"
                    (searchStringChanged)="viewSourceError = ''"
                    [clearOnBlur]="false"
                    [disabled]="sourceType === seriesType.allSavedCoverage || sourceType === seriesType.allCuratedCoverageInBrief || sourceType === seriesType.currentSearch || sourceType === seriesType.coverageSurge || block?.displayElement?.automaticallyGenerated"
                    [ariaLabel]="ariaLabel[sourceType]"
                    [ariaInvalid]="ariaInvalid || field.showDataSourceError || block?.errors.length > 0"
                    [ariaDescribedBy]="'dataSource_errors' + ariaDescribedBy"
                    [showHiddenOption]="showHiddenOption"
                    [agprTooltip]="(block?.displayElement?.automaticallyGenerated ? 'PageBuilder.blockType.curation.source.lock' : '') | localize"
                ></agpr-autocomplete>
            </div>
            <agpr-filter-dropdown
                id="bulkActionFilters"
                *ngIf="field.showFilters"
                [disabled]="(((sourceType !== seriesType.allSavedCoverage && sourceType !== seriesType.currentSearch) && !(value && value.id)) || sourceType === seriesType.coverageInSection || sourceType === seriesType.coverageSurge) || block?.displayElement?.automaticallyGenerated"
                class="agpr-monitoringSourcePickerField-filter"
                [ariaDescribedBy]="'bulkActionFilters.chips'"
                [agprTooltip]="(block?.displayElement?.automaticallyGenerated ? 'PageBuilder.blockType.curation.source.lock' : '') | localize"
            ></agpr-filter-dropdown>
        </div>
        <div
            *ngIf="field.showFilters && !field.horizontalOrientation"
            class="agpr-monitoringSourcePickerField-chips"
        >
            <agpr-filter-chips
                [readonly]="sourceType === seriesType.coverageInSection || sourceType === seriesType.coverageSurge"
                [id]="'bulkActionFilters.chips'"
            ></agpr-filter-chips>
        </div>
    </div>
    @if (!field.horizontalOrientation && field.separatedErrors && showErrors) {
        <ng-container *ngTemplateOutlet="dataSourceSeparatedErrors"></ng-container>
    }
    @if (!field.horizontalOrientation && viewSourceError) {
        <ng-container *ngTemplateOutlet="dataSourceViewSourceErrors"></ng-container>
    }
    <div
        *ngIf="!hideDateRecurring && field.showDateRange && (sourceType !== seriesType.allCuratedCoverageInBrief) && (sourceType !== seriesType.coverageInSection)"
        class="agpr-monitoringSourcePickerField-dateSelector"
        [class.agpr-monitoringSourcePickerField-dateFilterWrapper]="field.horizontalOrientation"
    >
        @if (quarterlyDateRange) {
            <div class="agpr-monitoringSourcePickerField-heading-dateRangeLabel agpr-monitoringSourcePickerField-heading-dateRangeLabel--quarterly">
                {{ field.dateRangeLabel | localize }}<span class="agpr-requiredAsterix"> * </span>
            </div>
            <div class="agpr-monitoringSourcePickerField-quarterlyDateRange" role="radiogroup">
                <agpr-radio
                    [id]="id + '.quarterly.calendarQuarters'"
                    label="Briefing.onlineBriefing.settings.dateRange.calendarQuarters"
                    [name]="id + '.quarterly_date_range_type'"
                    [value]="true"
                    [(ngModel)]="quarterlySettings.isCalendarQuarters"
                    (ngModelChange)="quarterTypeChanged()"
                ></agpr-radio>
                @if (quarterlySettings.isCalendarQuarters) {
                    <div class="agpr-monitoringSourcePickerField-quarterlyDateRange-row">
                        <agpr-dropdown
                            [id]="id + '.quarterly.quarterSelect'"
                            [options]="effectiveCalendarQuarterOptions"
                            [(ngModel)]="selectedQuarterOption"
                            (ngModelChange)="quarterSelectionChanged()"
                        ></agpr-dropdown>
                        @if (quarterlySettings.selectedQuarter !== quarterOptionEnum.MOST_RECENT) {
                            <agpr-dropdown
                                [id]="id + '.quarterly.yearSelect'"
                                [options]="yearOptions"
                                [(ngModel)]="selectedYearOption"
                                (ngModelChange)="quarterSelectionChanged()"
                            ></agpr-dropdown>
                        }
                    </div>
                }
                <agpr-radio
                    [id]="id + '.quarterly.fiscalQuarters'"
                    label="Briefing.onlineBriefing.settings.dateRange.fiscalQuarters"
                    [name]="id + '.quarterly_date_range_type'"
                    [value]="false"
                    [(ngModel)]="quarterlySettings.isCalendarQuarters"
                    (ngModelChange)="quarterTypeChanged()"
                ></agpr-radio>
                @if (!quarterlySettings.isCalendarQuarters) {
                    <div class="agpr-monitoringSourcePickerField-quarterlyDateRange-row">
                        <agpr-dropdown
                            [id]="id + '.quarterly.fiscalQuarterSelect'"
                            [options]="effectiveFiscalQuarterOptions"
                            [(ngModel)]="selectedQuarterOption"
                            (ngModelChange)="quarterSelectionChanged()"
                        ></agpr-dropdown>
                        @if (quarterlySettings.selectedQuarter !== quarterOptionEnum.MOST_RECENT) {
                            <agpr-dropdown
                                [id]="id + '.quarterly.fiscalYearSelect'"
                                [options]="yearOptions"
                                [(ngModel)]="selectedYearOption"
                                (ngModelChange)="quarterSelectionChanged()"
                            ></agpr-dropdown>
                        }
                    </div>
                }
            </div>
        } @else if (monthlyDateRange) {
            <div class="agpr-monitoringSourcePickerField-heading-dateRangeLabel agpr-monitoringSourcePickerField-heading-dateRangeLabel--quarterly">
                {{ field.dateRangeLabel | localize }}<span class="agpr-requiredAsterix"> * </span>
            </div>
            <div class="agpr-monitoringSourcePickerField-quarterlyDateRange" role="radiogroup">
                <agpr-radio
                    [id]="id + '.monthly.month'"
                    label="Briefing.onlineBriefing.settings.dateRange.month"
                    [name]="id + '.monthly_date_range_type'"
                    [value]="true"
                    [(ngModel)]="monthlySettings.isCalendarMonths"
                    (ngModelChange)="monthTypeChanged()"
                ></agpr-radio>
                @if (monthlySettings.isCalendarMonths) {
                    <div class="agpr-monitoringSourcePickerField-quarterlyDateRange-row">
                        <agpr-dropdown
                            [id]="id + '.monthly.monthSelect'"
                            [options]="effectiveCalendarMonthOptions"
                            [(ngModel)]="selectedMonthOption"
                            (ngModelChange)="monthSelectionChanged()"
                        ></agpr-dropdown>
                        @if (monthlySettings.selectedMonth !== monthOptionEnum.MOST_RECENT) {
                            <agpr-dropdown
                                [id]="id + '.monthly.yearSelect'"
                                [options]="monthYearOptions"
                                [(ngModel)]="selectedMonthYearOption"
                                (ngModelChange)="monthSelectionChanged()"
                            ></agpr-dropdown>
                        }
                    </div>
                }
                <agpr-radio
                    [id]="id + '.monthly.custom'"
                    label="Common.dateQueryInput.custom"
                    [name]="id + '.quarterly_date_range_type'"
                    [value]="false"
                    [(ngModel)]="monthlySettings.isCalendarMonths"
                    (ngModelChange)="monthTypeChanged()"
                ></agpr-radio>
                @if (!monthlySettings.isCalendarMonths) {
                    <div class="agpr-monitoringSourcePickerField-quarterlyDateRange-row">
                        <agpr-date-query-popup
                            [id]="id + '.dateFilterOptions'"
                            [(ngModel)]="dateQuery"
                            [header]="'Monitoring.dateQueryDialog.header'"
                            [options]="effectiveDateFilterOptions"
                            [dateTypeOptions]="dateTypeOptions"
                            [searchRange]="(sourceType === seriesType.topic) ? searchRange : null"
                            [disabled]="block?.displayElement?.automaticallyGenerated"
                            [dropdownInfoTooltip]="isSurgePeriodSelected ? 'Monitoring.sourcePickerField.surgePeriod.tooltip' : null"
                            (ngModelChange)="dateRangeChanged($event)"
                            [agprTooltip]="(block?.displayElement?.automaticallyGenerated ? 'PageBuilder.blockType.curation.source.lock' : '') | localize"
                        >
                        </agpr-date-query-popup>
                    </div>
                }
            </div>
        } @else {
            @if (field.horizontalOrientation) {
                <div class="agpr-monitoringSourcePickerField-heading-dateRangeLabel">
                    {{ field.dateRangeLabel | localize }}
                </div>
            }

            <agpr-date-query-popup
                [id]="id + '.dateFilterOptions'"
                [(ngModel)]="dateQuery"
                [header]="'Monitoring.dateQueryDialog.header'"
                [options]="dateFilterOptions"
                [dateTypeOptions]="dateTypeOptions"
                [searchRange]="(sourceType === seriesType.topic) ? searchRange : null"
                [disabled]="block?.displayElement?.automaticallyGenerated"
                [dropdownInfoTooltip]="isSurgePeriodSelected ? 'Monitoring.sourcePickerField.surgePeriod.tooltip' : null"
                (ngModelChange)="dateRangeChanged($event)"
                [agprTooltip]="(block?.displayElement?.automaticallyGenerated ? 'PageBuilder.blockType.curation.source.lock' : '') | localize"
            >
            </agpr-date-query-popup>
        }
    </div>
    @if (showSortOrder) {
        <div class="agpr-monitoringSourcePickerField-sorting">
            <div class="agpr-monitoringSourcePickerField-heading">
                <div class="agpr-monitoringSourcePickerField-heading-dataSourceLabel">{{'Monitoring.result.sortMentions' | localize}}</div>
            </div>
            <agpr-mentions-sort-order
                [id]="id"
                [showSelectedSortOrderLabel]="true"
                [style]="agprComponentStyleEnum.default"
            ></agpr-mentions-sort-order>
        </div>
    }
</div>
@if (!field.horizontalOrientation && showErrors) {
    <ng-container *ngTemplateOutlet="dataSourceErrors"></ng-container>
}

<div
    *ngIf="field.horizontalOrientation"
    class="agpr-monitoringSourcePickerField-horizontalRow2"
>
    <div
        *ngIf="field.showFilters"
        class="agpr-monitoringSourcePickerField-chips agpr-monitoringSourcePickerField-chips--horizontal"
    >
        <agpr-filter-chips
            id="bulkActionFilters.chips"
        ></agpr-filter-chips>
    </div>
    @if (showErrors) {
        <ng-container *ngTemplateOutlet="dataSourceErrors"></ng-container>
    }
</div>

@if (!hideDateRecurring) {
    @if (field.showResultsFeedback) {
        <agpr-message
            *ngIf="!(field.showTooManyMentionsError && numberOfResults > field.maxNumberOfMentions)"
            [severity]="messageSeverityEnum.info"
            [loading]="field.showLoadingFeedback && isLoadingResults"
        >
            {{ field.mentionCountLocalizationLabel | localize: {'number' : (numberOfResults ? numberOfResults : '0')} }}
        </agpr-message>
        <agpr-message
            *ngIf="field.showTooManyMentionsError && numberOfResults > field.maxNumberOfMentions"
            [severity]="messageSeverityEnum.warning"
            [loading]="field.showLoadingFeedback && isLoadingResults"
        >
            <div>{{ field.mentionCountLimitExceededLocalizationTitle | localize: {'number' : (numberOfResults ? numberOfResults : '0') } }}</div>
            <div>{{ field.mentionCountLimitExceededLocalizationLabel | localize: {'number' : (numberOfResults ? numberOfResults : '0'), 'maxNumber' : field.maxNumberOfMentions} }}</div>
        </agpr-message>
    }
    @if (field.showResultsFeedbackAnalysis) {
        <agpr-message
            *ngIf="(numberOfResults < field.warningNumberOfMentions)"
            [severity]="messageSeverityEnum.info"
            [loading]="field.showLoadingFeedback && isLoadingResults"
        >
            {{ field.mentionCountLocalizationLabel | localize: {'number' : (numberOfResults ? numberOfResults : '0')} }}
        </agpr-message>
        <agpr-message
            *ngIf="(numberOfResults > field.warningNumberOfMentions) && (numberOfResults < field.maxNumberOfMentions)"
            [severity]="messageSeverityEnum.warning"
            [loading]="field.showLoadingFeedback && isLoadingResults"
        >
            <div>{{ field.mentionCountLocalizationLabel | localize: {'number' : (numberOfResults ? numberOfResults : '0') } }}</div>
            <div>{{ field.mentionCountLimitExceededLocalizationTitle | localize }}</div>
        </agpr-message>
        <agpr-message
            *ngIf="numberOfResults > field.maxNumberOfMentions"
            [severity]="messageSeverityEnum.error"
            [loading]="field.showLoadingFeedback && isLoadingResults"
        >
            <div>{{ field.mentionCountLocalizationLabel | localize: {'number' : (numberOfResults ? numberOfResults : '0') } }}</div>
            <div>{{ field.mentionCountLimitExceededLocalizationLabel | localize }}</div>
        </agpr-message>
    }
}

@if (hideDateRecurring) {
    <agpr-message
        [severity]="messageSeverityEnum.info"
    >
        {{ 'Briefings.analysis.dateRange.notAvailable' | localize }}
    </agpr-message>
}


<ng-template #dataSourceErrors>
    <ul [id]="id + '_dataSource_errors'">
        <li>
            @if (field.showDataSourceError && field.dataSourceNullErrorMessage && !field.separatedErrors) {
                <agpr-form-message>
                    {{ field.dataSourceNullErrorMessage | localize }}
                </agpr-form-message>
            }

        </li>
        @for (errorMessage of block?.errors; track $index) {
            @if (errorMessage !== 'Briefings.analysis.errors.customPromptIsRequired' && errorMessage !== 'Briefings.analysis.errors.noManualKeywords') {
                <li>
                    <agpr-form-message>
                        {{ errorMessage | localize }}
                    </agpr-form-message>
                </li>
            }
        }
    </ul>
</ng-template>

<ng-template #dataSourceSeparatedErrors>
    @if (field.showDataSourceError && field.dataSourceNullErrorMessage) {
        <agpr-form-message
            [id]="id + '_dataSource_error'"
            class="agpr-monitoringSourcePickerField-datasource-error"
        >
            {{ field.dataSourceNullErrorMessage | localize }}
        </agpr-form-message>
    }
</ng-template>

<ng-template #dataSourceViewSourceErrors>
    <agpr-form-message
        [id]="id + '_dataSource_error'"
        class="agpr-monitoringSourcePickerField-datasource-error"
    >
        {{ viewSourceError | localize }}
    </agpr-form-message>
</ng-template>

